import ErrorBoundary from "@/components/ErrorBoundary";
import Button from "@/components/Button";
import { useNavigate } from "@/router";

export default function UniversityNotFoundErrorBoundary() {
  const navigate = useNavigate();

  return (
    <div className="flex items-center justify-center min-h-[60vh] p-6">
      <ErrorBoundary
        title="University Not Found"
        message="The university you're looking for could not be found. It may not exist or you may not have permission to view it."
        image="default"
        variant="fullPage"
        action={
          <Button
            variant="filled"
            onClick={() => navigate("/education/universities")}
            testId="return-to-universities-button"
          >
            Return to Universities
          </Button>
        }
      />
    </div>
  );
}
